import { ColumnType } from "antd/es/table";
import {
  ColumnType as CustomColumnType,
  TableCellType,
} from "../../models/tableModels";
import { ScreenerDataSourceType } from "../../models/tableModels";
import {
  HoldingCompaniesMetricsRequest,
  ScreenerConfigType,
} from "../../types/ScreenerTypes";

interface BaseColumnType extends ColumnType<ScreenerDataSourceType> {
  originalKey?: string;
}

export const SCREENER_BASE_COLUMNS: BaseColumnType[] = [
  {
    title: "Company Name",
    key: "companyAndLogo",
    originalKey: "name",
    dataIndex: "companyAndLogo",
    fixed: "left",
    sorter: true,
  },
  {
    title: "Sector",
    key: "sector",
    originalKey: "gics_sector_name",
    dataIndex: "sector",
  },
  { title: "Currency", key: "currency", dataIndex: "currency" },
  {
    title: "Revenue (mCRNCY)",
    key: "revenue",
    dataIndex: "revenue",
    sorter: true,
  },
  { title: "Added On", key: "added_on", dataIndex: "added_on", sorter: true },
  {
    title: "Holding Weight",
    key: "holding_weight",
    dataIndex: "holding_weight",
    sorter: true,
  },
];

export const FLAG_OPTIONS_COLUMN: ColumnType<ScreenerDataSourceType>[] = [
  {
    key: "flagsDropdown",
    title: "Flag",
    dataIndex: "flagsDropdown",
    fixed: "right",
  },
];

export const SCREENER_COLUMN_TYPES: CustomColumnType[] = [
  { type: TableCellType.COMPANY_LOGO, columnKey: "companyAndLogo" },
  { type: TableCellType.PERCENTAGE, columnKey: "holding_weight" },
  { type: TableCellType.DROPDOWN, columnKey: "flagsDropdown" },
  { type: TableCellType.DATE, columnKey: "added_on" },
  { type: TableCellType.TEXT, columnKey: "Base_year" },
];

export const METRIC_TYPES = [
  "tCO2e/mCRNCY",
  "Year",
  "mCRNCY",
  "Ranking",
  "C°",
  "millionTns",
  "Text",
  "tCO2e",
  "GWh",
  "%",
];
export const PAGE_SIZE = 40;

const DEFAULT_METRICS_LENGTH = 1;

export const BASE_PARAMETERS: HoldingCompaniesMetricsRequest = {
  filters: {
    portfolio_index_id: "",
    metrics: ["Base_year"],
    base_column_filters: [],
  },
  pagination: {
    page: 1,
    page_size: PAGE_SIZE * DEFAULT_METRICS_LENGTH,
  },
};

export const BASE_CONFIG: ScreenerConfigType = {
  holding_companies: [],
  distinct_metrics: [],
  gics_sectors: [],
};
